import { render, staticRenderFns } from "./AddNewStatusEvent.vue?vue&type=template&id=00bd5818&scoped=true"
import script from "./AddNewStatusEvent.vue?vue&type=script&lang=ts"
export * from "./AddNewStatusEvent.vue?vue&type=script&lang=ts"
import style0 from "./AddNewStatusEvent.vue?vue&type=style&index=0&id=00bd5818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bd5818",
  null
  
)

export default component.exports